import { s3FileSchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const emptyObject = {};

const responseSchema = z.object({
  documentationFiles: z.array(s3FileSchema),
});

interface Params {
  prefix?: string;
}

export function useDocumentationDocs({ prefix }: Params = emptyObject) {
  const url = `/documentation${objectToQueryParams({
    prefix,
  })}`;

  const { data, error, isLoading, refetch, isFetching } = useQuery({
    queryKey: queryKeys.getDocumentationDocs(prefix),
    queryFn: () => get({ url, schema: responseSchema }),
  });

  return {
    documentationFiles: data?.documentationFiles || [],
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
